import { render, staticRenderFns } from "./orderstatus.vue?vue&type=template&id=46775e8c&scoped=true&"
import script from "./orderstatus.vue?vue&type=script&lang=js&"
export * from "./orderstatus.vue?vue&type=script&lang=js&"
import style0 from "./orderstatus.vue?vue&type=style&index=0&id=46775e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46775e8c",
  null
  
)

export default component.exports